<template>
    <div>
        <form @submit.prevent="submit" class="ajax_off">
            <b-button variant="success" @click="$bvModal.show('addContatoModal')"><i class="fas fa-user"></i> Adicionar
                Contato</b-button>

            <hr>
            <label v-if="contacts.length > 0">Enviar para:</label>
            <EmailSelector v-if="contacts.length > 0" :contacts="contacts" @input="updateContacts($event)"></EmailSelector>
            <div class="form-group">
                <trumbowyg v-model="notification.message" :config="editor_config" @tbw-paste="trumbowygPaste"
                    class="form-control" name="content">
                </trumbowyg>
                <span v-if="notification.message && notification.message.length > 0">Limite de caracteres {{ notification.message.length }}/{{ limit_characters
                }}</span>
            </div>
        </form>
        <div clas="form-group" v-if="notification.anexo == null">
            <b-button variant="outline-secondary" @click.prevent="$bvModal.show('anexos')">Anexar Documento</b-button>
        </div>

        <div clas="form-group" v-else>
            Documento anexado
            {{ notification.anexo.arquivo_name }}
            <b-button variant="outline-secondary" @click="notification.anexo = null">x</b-button>
        </div>


        <div class="form-group mt-3">
            <b-button variant="primary" @click.prevent="sendNow()"><i class="fas fa-paper-plane"></i> Notificar
                agora</b-button>
        </div>
        <modal title="Adicionar contato" form="contatoForm" id="addContatoModal" size="md" btn_save>
            <ContaForm @addContact="addContact()" :processo_id="processo.id"></ContaForm>
        </modal>
        <modal title="Adicionar Anexo" id="anexos">
            <anexos selecionar showForm v-if="processo.cliente.cliente_documento"
                :cliente_documento="processo.cliente.cliente_documento" @arquivoSelecionado="anexo($event)" />
        </modal>
    </div>
</template>
<script>
import Trumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/ui/trumbowyg.css";
import ContaForm from './ContatoForm.vue';
import EmailSelector from "../../sistema/EmailSelector.vue";
import Anexos from "../../sistema/Anexos.vue";

export default {
    components: { ContaForm, Trumbowyg, EmailSelector, Anexos },
    props: {
        cliente_documento: String,
        tarefa_id: Number,
        processo: Object,
    },
    watch: {
        limit_characters(newVal, oldVal) {
            if (newVal.length >= this.limit_characters) {
                this.notification.message = oldVal;
            }
        }
    },
    data() {
        return {
            limit_characters: 850,
            contacts: [],
            notification: {
                anexo: null,
                contacts: [],
                message: "",

            },
            editor_config: {
                plugins: {
                    allowTagsFromPaste: {
                        allowedTags: ["h4", "p", "br"],
                    },
                },
                autogrow: true,
                btns: [
                    ["undo", "redo"], // Only supported in Blink browsers
                    ["formatting"],
                    ["strong", "em"],
                    ["link"],
                    ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
                    ["unorderedList", "orderedList"],
                    ["removeformat"],
                ],
            },
        }
    },
    mounted() {
        this.getContacts();
        this.getLastMessage();
    },
    methods: {
        async getLastMessage() {

            await this.$api.get(`lastmessage-processo/${this.processo.id}`).then((json) => {
                this.notification.message = json.data.notification_message;

            });
        },
        remover(id, nome) {
            this.$swal({
                title: `Remover contato ${nome}?`,
                html: `<p>O contato não receberá mais notificações.</p>`,
                showDenyButton: true,
                confirmButtonText: "Remover Contato",
                denyButtonText: `Manter Contato`,
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !this.$swal.isLoading(),
                preConfirm: () => {
                    return this.$api
                        .delete(`processo-contact/${id}`)
                        .then((response) => {
                            if (response.status != 200) {
                                throw new Error("Ocorreu um erro inesperado");
                            }

                            this.getContacts();


                            return response.data;
                        })
                        .catch((error) => {
                            this.$swal.showValidationMessage(
                                `Serviço temporariamente indisponivel: ${error}`
                            );
                        });
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    this.getContacts();
                    console.log("cancelado com sucesso!");
                }
            });
        },
        updateContacts(contacts) {
            this.notification.contacts = contacts;
        },
        async getContacts() {
            let result = await this.$api.get(`processo-contact/${this.processo.id}`);
            this.contacts = [];
            if (result.data.length)
                this.contacts = result.data;
        },
        async sendNow() {
            this.notification.processo_id = this.processo.id;
            await this.$api.post('notify-processo', this.notification);

            this.$bvModal.hide('notificationProcesso');


        },
        addContact() {
            this.getContacts();
        },
        anexo(anexo) {
            this.notification.anexo = anexo;
        }


    },
}
</script>
